<template>
	<div class="aside-wrap">
		<div class="aside-title">
			<div class="title-l">
				<!-- <div class="title-icon">
					<img src="@/assets/follow_icon.png" />
				</div> -->
				<h3>推荐关注</h3>
			</div>
		</div>
		<div class="aside-content">
			<div class="card-list" v-for="item in dataList" :key="item.id">
				<div class="userinfo" @click="toDetail(item.id)">
					<div class="userinfo-l">
						<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
					</div>
					<div class="userinfo-r">
						<div class="username-wrap">
							<div class="username">{{ item.nickName }}</div>
						</div>
						<div class="userinfo-tips">{{item.fansNum}}人已关注</div>
					</div>
				</div>
				<div v-if="item.isFollow==1" class="follow-btn followed" @click="toFollow(item)">+ 已关注</div>
				<div v-else class="follow-btn" @click="toFollow(item)">+ 关注</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'asideFollow',
		components: {
		},
		data(){
			return {
				pageNum: 1,
				pageSize: 8,
				dataList: [],
				userId: ''
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.getDataList()
		},
		methods: {
			//获取数据列表
			async getDataList(){
				let param = {
					userId: this.userId,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/index/recommendUser', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//关注 取消关注
			async toFollow(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					followUserId: item.id,
					followFlag: item.isFollow==1?0:1
				}
				ajaxParam(param)
				const res = await post('v1/circle/followUser', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					if(item.isFollow==1) {
						this.$message.success('取消关注成功！')
					} else {
						this.$message.success('关注成功！')
					}
					item.isFollow = item.isFollow==1?0:1
					
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toDetail(id){
				this.$router.push({
					path: '/userIndex?id='+id
				})
			}
		}
	}
</script>

<style scoped lang="less">
	@import './common.less';
	.title-icon{
		background: #3FAD4E;
	}
	.aside-content {
		padding: 20px;
		
	}
	.card-list{
		cursor: pointer;
	}
	.username{
		width:120px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
